var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conpound-container"},[(!_vm.preview && !_vm.isPreview)?_c('div',{staticClass:"text-container"},[_c('span',[_vm._v("内嵌网页："+_vm._s(_vm.finalSRC))])]):_c('iframe',{staticClass:"inner-iframe",attrs:{"src":_vm.finalSRC,"id":"inner-iframe"},on:{"load":function($event){return _vm.loaded()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }